<div *ngIf="params$ | async" class="content_menu_wrapper" [style.left.px]="(params$ | async)?.left" [style.top.px]="(params$ | async)?.top">
  <content-menu-batch
    *ngIf="tasks$ | async"
    [batchTasksInput$]="tasks$"
    [editPermissions]="isNotGuest"
    [boardId]="boardId$ | async"
  ></content-menu-batch>
</div>
